import React from 'react';
import { useSelector } from 'react-redux';
import LoadingCircle from '@cpg-its/ads.common.loading-circle';
import { useNewHireSettings } from '../../new-hire/hooks/useNewHireSettings';
import NewHireConfirmationView from './new-hire-confirmation-view';
import { useQuery } from '../../../../../global/hooks/useQuery';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { NewHireProps } from '../../../models/arc-epi-props';
import { Breadcrumbs } from '../../../../../global/components/breadcrumbs';
import { TcsmSiteSettingsProps } from '../../../../../global/models/epi-model';

interface Props {
	settignsId: string;
	hideBreadCrumbs?: boolean;
}

const defaultStatus = 'default';


export function NewHireEnrollmentConfirmation(props: Props) {

	const { settignsId, hideBreadCrumbs } = props;
	const settingLoaded = useNewHireSettings(settignsId);
	const newHireSettings = useSelector<TcsmStates, NewHireProps>(state => state?.epiProps?.newHireSettingsState?.epiContent);
	const query = useQuery()?.get('status') || defaultStatus;
	const siteSettings = useSelector<TcsmStates, TcsmSiteSettingsProps>(state => state?.epiProps?.siteSettingsState?.siteSettings);
	if (!settingLoaded) {
		return <LoadingCircle />;
	}

	const model = newHireSettings?.newHireConfirmationPageSettings?.find(m => m?.statusCode === query);

	return (
		<>
			{!hideBreadCrumbs && <Breadcrumbs routeBreadcrumbs={siteSettings?.routeBreadcrumbs} />}
			<NewHireConfirmationView model={model} />
		</>
	);
}

NewHireEnrollmentConfirmation.defaultProps = {
	hideBreadCrumbs: false,
};